import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMouseClassic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"mouse-classic, click"} maskId="square-filled-radius-0-stroke-1-IconMouseClassic"><path d="M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V10H19V15Z" fill="currentColor"/><path d="M11.5 9H5C5 5.30217 7.86743 2.27597 11.5 2.01953V9Z" fill="currentColor"/><path d="M12.5 2.01953C16.1326 2.27597 19 5.30217 19 9H12.5V2.01953Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMouseClassic;
